import { render, staticRenderFns } from "./materialReceiveList.vue?vue&type=template&id=86767fbc&scoped=true"
import script from "./materialReceiveList.vue?vue&type=script&lang=js"
export * from "./materialReceiveList.vue?vue&type=script&lang=js"
import style0 from "./materialReceiveList.vue?vue&type=style&index=0&id=86767fbc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86767fbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86767fbc')) {
      api.createRecord('86767fbc', component.options)
    } else {
      api.reload('86767fbc', component.options)
    }
    module.hot.accept("./materialReceiveList.vue?vue&type=template&id=86767fbc&scoped=true", function () {
      api.rerender('86767fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/downLoadCenter/materialReceiveList.vue"
export default component.exports